import { ChargeablePreauthorizationsParameters, useRepositoryQuery } from '@mews-commander/data-access';

export const useGetChargeablePreauthorizations = ({
    customerId,
    preauthorizationId,
    billId,
}: ChargeablePreauthorizationsParameters) =>
    useRepositoryQuery('chargeablePreauthorizations', 'getAll', { customerId, preauthorizationId, billId });
